/*
  "+$92 motorized" under each card on a motorized collection.

  The amount is the CRM calculator's motorized add-on for that product (filled
  from PPO's cheapest motorized configuration), asked for once per page. A card
  whose product has no amount keeps its line hidden, so nothing half-empty shows.
  Cards added later (a facet change re-rendering the grid) are filled from the
  same answer, and only unseen handles trigger another request.
*/
(function () {
  var script = document.currentScript;
  var base = ((script && script.dataset.base) || "").replace(/\/+$/, "");
  if (!base) return;

  var known = {};
  var asked = {};

  function money(n) {
    return "$" + (Math.round(n) === n ? String(n) : n.toFixed(2));
  }

  function paint() {
    var lines = document.querySelectorAll("[data-motor-handle]");
    for (var i = 0; i < lines.length; i++) {
      var el = lines[i];
      var amount = known[el.getAttribute("data-motor-handle")];
      if (typeof amount === "number" && amount > 0) {
        var text = "+" + money(amount) + " motorized";
        // Only write on a change: every write is a mutation, and the observer below would loop.
        if (el.textContent !== text) el.textContent = text;
        if (el.hidden) el.hidden = false;
      }
    }
  }

  function fill() {
    var lines = document.querySelectorAll("[data-motor-handle]");
    var wanted = [];
    for (var i = 0; i < lines.length; i++) {
      var h = (lines[i].getAttribute("data-motor-handle") || "").toLowerCase();
      if (h && !asked[h] && wanted.indexOf(h) === -1) wanted.push(h);
    }
    paint();
    if (!wanted.length) return;
    wanted.forEach(function (h) { asked[h] = true; });
    fetch(base + "/api/calculator/public/motorized?handles=" + encodeURIComponent(wanted.join(",")))
      .then(function (r) { return r.ok ? r.json() : { upcharges: {} }; })
      .then(function (data) {
        var up = (data && data.upcharges) || {};
        for (var k in up) if (Object.prototype.hasOwnProperty.call(up, k)) known[k] = Number(up[k]);
        paint();
      })
      .catch(function () { /* No amount, no line: the card is complete without it. */ });
  }

  fill();
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; fill(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
